import { createContext, useContext, type ReactNode } from 'react';
import type { PageAgentChat } from './page-agent';

export type RenderPageAgentChat = (chat: PageAgentChat) => ReactNode;

/**
 * How the app draws a page agent's chat. The chat is the chat page's own `ChatSession`, which no
 * layer below the app may import, so the app hands it down here once for every page.
 */
export const PageAgentRendererContext = createContext<RenderPageAgentChat | null>(null);

export function usePageAgentRenderer(): RenderPageAgentChat | null {
  return useContext(PageAgentRendererContext);
}
